import { Component } from '@angular/core';

@Component({
  selector: 'app-generic-footer-simplified',
  templateUrl: './footer-simplified.component.html',
  styleUrls: ['./footer-simplified.component.scss']
})
export class FooterSimplifiedComponent { }
